import Supercard from './Supercard'
export default Supercard